module.exports = __webpack_public_path__ + "a3b71cc8a53779e1bdd9d4710767e11e.png";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/img/profile-photo.png
// module id = 207
// module chunks = 0